import CloseIcon from "@mui/icons-material/Close";
import MailIcon from "@mui/icons-material/Mail";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Card } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";
import DraggableDialog from "components/UpStyled/DraggableDialog";
import ChatIcon from "components/Icon/ChatIcon";
import AddToPhotosIcon from "@mui/icons-material/AddToPhotos";
import { Badge } from "@mui/material";

import { AccountContext } from "context/account";
import { navbarIconButton } from "examples/Navbars/DashboardNavbar/styles";
import { nanoid } from "nanoid";
import Comments from "pages/comment";
import ResourceOwner from "pages/de/share-page/components/ResourceOwner";
import SharedUserList2 from "pages/de/share-page/components/SharedUserList2";
import ShareListModal from "pages/de/share-page/components/ShareListModal";
import ChatRoom from "pages/messages/chatroom";
import { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import api from "services/api";
import { backendServer } from "services/request";
import socketIOClient from "socket.io-client";
import PublishIcon from "@mui/icons-material/Publish";
import UnpublishedIcon from "@mui/icons-material/Unpublished";
import CollectionsIcon from "@mui/icons-material/Collections";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import ShareIcon from "@mui/icons-material/Share";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import BlockIcon from "@mui/icons-material/Block";

import CreateCollectionModal from "pages/de/collection/components/CreateCollectionModal";
import Prompt from "components/UpStyled/Prompt";
import ImportSingleStyleModal from "pages/de/portfolio/components/ImportSingleStyleModal";
import ImportSingleCollectionModal from "pages/de/portfolio/components/ImportSingleCollectionModal";
import SetMoodboardCollectionModal from "pages/de/collection/moodboards/components/SetMoodboardCollectionModal";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import StartIcon from "@mui/icons-material/Start";
import ClassIcon from "@mui/icons-material/Class";

import { isInPortfolio } from "utils/helper";
import {
  canResizeImageUrl,
  getStyleImages,
  getFileImage,
  getOnLineTechPackImages,
} from "utils/imageHelper";
import { MAX_SCREEN_WIDTH } from "utils/data";

const NEW_CHAT_MESSAGE_EVENT = "newChatMessage"; // Name of the event

const SLOT_MAP = {
  collection: {
    slot: "col_0",
    name: "collection",
    section: "featured collection",
    type: "collection",
  },
  moodboard: {
    slot: "moodboard_0",
    name: "moodboard",
    section: "Moodboard",
    type: "moodboard",
  },
  product: {
    slot: "style_0",
    name: "style",
    section: "featured styles",
    type: "style",
  },
  size_chart: {
    slot: "sizeChart_0",
    name: "size chart",
    section: "size charts",
    type: "size_chart",
  },
};
const metaFilesKey = ["imageFiles"];

const NewSharedBar = ({
  data,
  type,
  shareSessionRef = null,
  handleRefreshSourceData = async () => {},
  title,
  ActionGroup,
  extraFunctions = {},
  extraAction,
}) => {
  const [loading, setLoading] = useState(true);
  const [shareVisible, setShareVisible] = useState(false);
  const [permittedUsers, setPermittedUsers] = useState([]); //user list for owner to view

  const [collaboratorUsers, setCollaboratorUsers] = useState([]); //user list for collaborators to view
  const [projectInfo, setProjectInfo] = useState({});
  const [projectProvider, setprojectProvider] = useState({});
  const [commentVisible, setCommentVisible] = useState(false);
  const [ownerStore, setOwnerStore] = useState({});
  const [sharedSessions, setSharedSessions] = useState([]);
  const [chatVisible, setChatVisible] = useState(false);
  const [currentRoom, setCurrentRoom] = useState(new Map());
  const [unpublishedMoodboard, setUnpublishedMoodboard] = useState(false); //confirm prompt//remove moodboard/style image to portfolio slot:gallery_0/style_0
  const [publishMoodboard, setPublishMoodboard] = useState(false); //confirm prompt//import moodboard/style image to portfolio slot:gallery_0/style_0
  const [importStyleVisible, setImportStyleVisible] = useState(false); //import style image to portfolio slot:style_0
  const [importCollectionVisible, setImportCollectionVisible] = useState(false); //import style images from current collection to portfolio slot:col_0
  const [actionmenuVisible, setActionmenuVisible] = useState(null);
  const [createCollectionVisible, setCreateCollectionVisible] = useState(false); //using current moodboard to create a collection
  const [collectionMoodboardVisible, setCollectionMoodboardVisible] = useState(false); //using current moodboard to a existed collection
  const [permittedCollectionUsers, setPermittedCollectionUsers] = useState([]);
  const [lockVisible, setLockVisible] = useState({});
  const [unlockVisible, setUnlockVisible] = useState({});
  const [shareToAllDesiignersVisible, setShareToAllDesiignersVisible] = useState(false);
  const [unshareToAllDesiignersVisible, setUnshareToAllDesiignersVisible] = useState(false);
  const [importStyleConfirmation, setImportStyleConfirmation] = useState(false);

  const account = useContext(AccountContext);
  const navigate = useNavigate();
  const isOwner = account.id == ownerStore?.id;

  let portfolioData = account?.metadata?.portfolio_content || {}; //user portfolio data
  let currentType = SLOT_MAP?.[type];
  const slot = currentType?.slot;
  let galleryData = portfolioData[slot] || [];
  const inPortfolio = galleryData.find((x) => x.id == data?.id);

  const sharedTitle = title ? title : data?.title || data?.name;
  const isSharedToAllDesigners = permittedUsers.find((x) => x.user_id == "AllDesigners") || {}; //for owner to check whether this item can be shared to all designers
  //for shared user to check whether this item can be imported/downloaded, only the item shared to all designers can be downloaded/imported
  const isSharedToAll = collaboratorUsers.find((x) => x.user_id == "AllDesigners") || {};
  //console.log('sharedSessions', sharedSessions)

  useEffect(() => {
    return async () => {
      if (shareSessionRef && shareSessionRef.current) {
        if (shareSessionRef.current.savefunc) await shareSessionRef.current.savefunc();
        var closemsg = {
          senderId: account.id,
          sessionId: shareSessionRef.current.id,
          action: "close",
          contacts: [],
          dt: new Date(),
        };
        shareSessionRef.current.socket?.emit(NEW_CHAT_MESSAGE_EVENT, closemsg, (data) => {
          shareSessionRef.current.socket?.close();
          //console.log('SharedBar component close', shareSessionRef.current.socket, closemsg)
          shareSessionRef.current.socket = null;
        });
      }
    };
  }, []);

  useEffect(() => {
    if (account.id && ownerStore?.id && !ActionGroup) {
      handleRefresh();
      if (type == "product" && data?.id) {
        getStyleProjectInfo();
      }
    }
    if (!ownerStore?.id && data?.id && !ActionGroup) {
      retrieveOwner(data);
      retrievePublicChats();
      //console.log('shareSessionRef setup', data.id, ownerStore?.id, account.id)
      if (shareSessionRef?.current) {
        shareSessionRef.current.type = type;
        shareSessionRef.current.user_id = account.id;
        shareSessionRef.current.sharedSessions = [];
        shareSessionRef.current.id = window.sessionStorage.getItem(type + "_session_id");
        if (shareSessionRef.current.id === null) {
          shareSessionRef.current.id = nanoid();
          window.sessionStorage.setItem(type + "_session_id", shareSessionRef.current.id);
        }
        shareSessionRef.current.others = [];
        shareSessionRef.current.socket = socketIOClient(backendServer, {
          query: { roomId: data.id },
        });
        shareSessionRef.current.socket.on(NEW_CHAT_MESSAGE_EVENT, (message) => {
          if (shareSessionRef.current.id === message.sessionId) return;
          //console.log('NEW_CHAT_MESSAGE_EVENT', message, shareSessionRef.current)
          if (message.action == "open") {
            if (
              !shareSessionRef.current.sharedSessions.find((s) => s.sessionId === message.sessionId)
            ) {
              shareSessionRef.current.sharedSessions = [
                ...shareSessionRef.current.sharedSessions,
                { senderId: message.senderId, sessionId: message.sessionId },
              ];
              var openmsg = {
                senderId: shareSessionRef.current.user_id,
                sessionId: shareSessionRef.current.id,
                action: "open",
                contacts: [],
                dt: new Date(),
              };
              //console.log('emit openmsg', openmsg)
              shareSessionRef.current.socket?.emit(NEW_CHAT_MESSAGE_EVENT, openmsg);
              setSharedSessions(shareSessionRef.current.sharedSessions);
            }
          } else if (message.action == "close") {
            shareSessionRef.current.sharedSessions = shareSessionRef.current.sharedSessions.filter(
              (s) => s.sessionId !== message.sessionId
            );

            setSharedSessions(shareSessionRef.current.sharedSessions);
          } else {
            if (shareSessionRef.current.refeshfunc) shareSessionRef.current.refeshfunc();
          }
        });
        shareSessionRef.current.socket.emit(NEW_CHAT_MESSAGE_EVENT, {
          senderId: account.id,
          sessionId: shareSessionRef.current.id,
          action: "open",
          contacts: [],
          dt: new Date(),
        });
      }
    }
  }, [data?.id, ownerStore?.id]);

  const retrieveOwner = async (item) => {
    try {
      setLoading(true);
      if (type == "product") {
        if (item.store) {
          setOwnerStore(item.store);
        } else {
          const { data } = await api.account.get(item?.store_id);
          setOwnerStore(data?.user?.stores?.[0] || {});
        }
        setLoading(false);
      } else if (type == "collection") {
        const { data } = await api.account.get(item?.store_id);

        setOwnerStore(data?.user?.stores?.[0] || {});
        setLoading(false);
      } else if (type == "moodboard") {
        const { data } = await api.account.get(item?.owner_id);

        setOwnerStore(data?.user?.stores?.[0] || {});
        setLoading(false);
      } else if (type == "size_chart") {
        const { data } = await api.account.get(item?.owner_id);

        setOwnerStore(data?.user?.stores?.[0] || {});
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      toast.error("Retrieve owner info failed");
      console.log(err);
    }
  };

  const retrieveUsersWithPermission = async () => {
    if (!data?.id || !type) {
      return;
    }
    try {
      let payload = {
        resource_type: type,
        resource_id: data.id,
        //resource_owner_id: ownerStore?.id,
      };
      let rp = {};
      if (isOwner) {
        setLoading(true);
        const rp2 = await api.resourcePermission.sharingList(payload);
        let userList2 = rp2?.data?.resource_permissions || [];
        let filteredList2 = removeDuplicate(userList2);
        setPermittedUsers(filteredList2 || []);
      }

      rp = await api.resourcePermission.retrieveCollaborators(payload);

      let userList = rp?.data?.resource_permissions || [];
      let filteredList = removeDuplicate(userList);
      setCollaboratorUsers(filteredList || []);
      setLoading(false);
      //
      const collectionUsers = filteredList.filter((x) => x.resource_type == "collection");
      setPermittedCollectionUsers(collectionUsers);
    } catch (err) {
      setLoading(false);
      console.log(err);
      //toast.error("Retrieve user access list failed!");
    }
  };

  const removeDuplicate = (userList) => {
    let idSet = new Set();
    let filteredList = [];
    for (let i = 0; i < userList.length; i++) {
      if (idSet.has(userList[i].user_id) || !userList[i].user) {
        //
      } else {
        idSet.add(userList[i].user_id);
        filteredList.push(userList[i]);
      }
    }
    return filteredList;
  };

  const handleRefresh = () => {
    retrieveUsersWithPermission();
  };

  const retrievePublicChats = async () => {
    if (data?.id) {
      try {
        var result = await api.chatroom.addChatRoom({
          name: "Discussion",
          regardingtype: 1,
          regardingid: data.id,
          userids: [],
        });
        setCurrentRoom(result.data);
      } catch (err) {
        console.log(err);
      }
    }
  };

  const getStyleProjectInfo = async () => {
    if (type == "product") {
      try {
        setLoading(true);
        const product = await api.products.listProjectsByStyle(data?.id);
        let myProjects = product?.data?.product?.projects || [];
        if (myProjects && myProjects.length > 0) {
          setProjectInfo(myProjects[0]);

          const provider = await api.account.get(myProjects[0].provider_id);
          const stores = provider?.data?.user?.stores || [];
          if (stores.length > 0) {
            setprojectProvider(stores[0]);
          }
        }
        setLoading(false);
      } catch (err) {
        setLoading(false);
        console.log(err);
      }
    }
  };
  const formatProjectInfo = (style) => {
    return (
      <SuiBox
        gap={1}
        sx={{
          px: 1,
          py: 1,
          display: { xs: "none", sm: "none", md: "none", lg: "block" },
          zIndex: 2,
        }}
      >
        <Tooltip title={projectInfo.name}>
          <SuiTypography
            variant="body1"
            fontWeight="regular"
            lineHeight="1.2"
            component={Link}
            to={`/produce/all-projects?id=${projectInfo.id}`}
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: "1",
              maxWidth: 300,
              WebkitBoxOrient: "vertical",
              zIndex: 2,
            }}
          >
            Project: {projectInfo.name}
          </SuiTypography>
        </Tooltip>
      </SuiBox>
    );
  };

  const handleUpdateCollection = async (selectedCollection, selectedStyleImgs) => {
    if (!slot) {
      toast.error("Can't find the selected slot!");
    }
    if (account.id) {
      let old_portfolio = account?.metadata?.portfolio_content || {};
      let new_portfolio = { ...old_portfolio };
      if (!old_portfolio[slot]) {
        old_portfolio[slot] = [];
      }
      let ids = [];
      let products = data?.products || [];
      for (let i = 0; i < products.length; i++) {
        let styleImages = getStyleImages(products[i], false, metaFilesKey);
        styleImages = styleImages.filter((f) => f?.type && f.type.includes("image")); //remove pdf format
        for (let j = 0; j < styleImages.length; j++) {
          const isSelected = selectedStyleImgs.find(
            (x) => x?.id == products[i].id && x?.img?.url == styleImages[j]?.url
          );

          if (isSelected) {
            //check if portfolio has it, if not then add it
            const findIndex = old_portfolio[slot].findIndex(
              (x) =>
                x?.cid == data?.id && x?.id == isSelected?.id && x?.img?.url == styleImages[j]?.url
            );
            if (findIndex < 0) {
              old_portfolio[slot].push({
                img: styleImages[j],
                id: products[i].id,
                type: "collection",
                title: products[i].title,
                cid: data?.id,
                ctitle: data?.title,
              });
            }
          } else {
            //check if portfolio has it, then remove it
            const findIndex = old_portfolio[slot].findIndex(
              (x) =>
                x?.cid == data?.id && x?.id == products[i]?.id && x?.img?.url == styleImages[j]?.url
            );
            if (findIndex >= 0) {
              old_portfolio[slot].splice(findIndex, 1);
            }
          }
        }
      }

      let payload = {
        metadata: {
          ...account?.metadata,
          portfolio_content: old_portfolio,
        },
      };
      try {
        const { data } = await api.account.update(account.id, payload);
        handleRefresh();
        setImportCollectionVisible(false);
        toast.success("Update collection images in portfolio successfully!");
      } catch (err) {
        console.log(err);
        toast.error("Update collection images in portfolio failed!");
      }
    } else {
      toast.error("Can't find the user!");
    }
  };

  //execute after create a collection
  const handleAfterCreateCollectionOk = async (newCreatedCollection) => {
    //need save moodboard before creatation
    let id = newCreatedCollection?.data?.collection?.id;
    //associate the moodboard with created collection
    if (id) {
      try {
        await api.moodboard.updateCollectionRelation(data?.id, {
          collection_id: id,
        });

        toast.success(`Set moodboard to collection successfully!`);

        //navigate to collection detail page
        navigate(`/workspace/collections?id=${id}`);
      } catch (err) {
        toast.error(`Set moodboard to collection failed!`);
      }
    } else {
      toast.error(`Can't find selected collection!`);
    }
  };

  const handleCloseStyleImportMenu = () => setActionmenuVisible(false);
  const handleToggleLock = () => {
    let temp = {};
    temp[type] = true;
    if (data?.mode == 2) {
      console.log("unlock", temp, data?.mode);
      setUnlockVisible(temp);
      setLockVisible({});
    } else {
      console.log("lock", temp, data?.mode);

      setLockVisible(temp);
      setUnlockVisible({});
    }
  };

  const ActionMenu = ({ isSharedToAllDesigners }) => (
    <Menu
      id="user-management-menu"
      anchorEl={actionmenuVisible}
      open={Boolean(actionmenuVisible)}
      onClose={handleCloseStyleImportMenu}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
      sx={{ zIndex: 10000 }}
    >
      {" "}
      {type == "product" && !projectInfo?.id ? (
        <Tooltip title={`Use current style to create a project.`} placement="left">
          <MenuItem>
            <Link to={`/produce/all-projects/create?import_style=${data.id}`}>
              <SuiBox display="flex" alignItems="center" justifyContent="flex-start" gap={1}>
                <StartIcon fontSize="small" />
                <SuiTypography variant="body1" textAlign="center">
                  Ready for manufacturing{" "}
                </SuiTypography>{" "}
              </SuiBox>
            </Link>
          </MenuItem>
        </Tooltip>
      ) : null}
      {type == "moodboard" && !data.collection_id && account.id == data.owner_id ? (
        <div>
          <Tooltip title={`Use current moodboard to create a collection.`} placement="left">
            <MenuItem>
              <SuiBox
                display="flex"
                alignItems="center"
                justifyContent="flex-start"
                gap={1}
                onClick={() => {
                  setCreateCollectionVisible(true);
                  handleCloseStyleImportMenu();
                }}
              >
                <AddToPhotosIcon fontSize="small" />

                <SuiBox>
                  <SuiTypography variant="body1" textAlign="center">
                    Create Collection
                  </SuiTypography>
                </SuiBox>
              </SuiBox>{" "}
            </MenuItem>
          </Tooltip>
          <Tooltip title={`Add current moodboard to an existing collection`} placement="left">
            <MenuItem>
              <SuiBox
                display="flex"
                alignItems="center"
                justifyContent="flex-start"
                gap={1}
                onClick={() => {
                  setCollectionMoodboardVisible(true);
                  handleCloseStyleImportMenu();
                }}
              >
                <CollectionsIcon fontSize="small" />

                <SuiBox>
                  <SuiTypography variant="body1" textAlign="center">
                    Add to an existing collection
                  </SuiTypography>
                </SuiBox>
              </SuiBox>{" "}
            </MenuItem>
          </Tooltip>
        </div>
      ) : null}
      {account.role == "admin" && isOwner ? (
        isSharedToAllDesigners.id ? (
          <Tooltip title={`Share this content to all designer!`} placement="left">
            <MenuItem>
              <SuiBox
                display="flex"
                alignItems="center"
                justifyContent="flex-start"
                gap={1}
                onClick={() => {
                  setUnshareToAllDesiignersVisible(true);
                  handleCloseStyleImportMenu();
                }}
              >
                <BlockIcon fontSize="small" />

                <SuiBox>
                  <SuiTypography variant="body1" textAlign="center">
                    Unshare to All Designers
                  </SuiTypography>
                </SuiBox>
              </SuiBox>{" "}
            </MenuItem>
          </Tooltip>
        ) : (
          <Tooltip title={`Share this content to all designer!`} placement="left">
            <MenuItem>
              <SuiBox
                display="flex"
                alignItems="center"
                justifyContent="flex-start"
                gap={1}
                onClick={() => {
                  setShareToAllDesiignersVisible(true);
                  handleCloseStyleImportMenu();
                }}
              >
                <ShareIcon fontSize="small" />

                <SuiBox>
                  <SuiTypography variant="body1" textAlign="center">
                    Share to All Designers
                  </SuiTypography>
                </SuiBox>
              </SuiBox>{" "}
            </MenuItem>
          </Tooltip>
        )
      ) : null}
      {type == "product" || type == "moodboard" ? (
        <Tooltip
          title={
            data?.mode == 2
              ? `UnLock the ${currentType?.name}, collaborators can edit the content with "Editor" permission.`
              : `Lock the ${currentType?.name}, all collaborators can only view the content.`
          }
          placement="left"
        >
          <MenuItem
            onClick={() => {
              handleToggleLock();
              handleCloseStyleImportMenu();
            }}
          >
            <SuiBox>
              <SuiBox sx={{ cursor: "pointer" }}>
                <SuiBox display="flex" alignItems="center" justifyContent="flex-start" gap={1}>
                  {data?.mode == 2 ? (
                    <LockOpenIcon fontSize="small" />
                  ) : (
                    <LockIcon fontSize="small" />
                  )}

                  <SuiTypography variant="body1" textAlign="center">
                    {data?.mode == 2 ? "Unlock" : "Lock"}
                  </SuiTypography>
                </SuiBox>
              </SuiBox>
            </SuiBox>
          </MenuItem>
        </Tooltip>
      ) : null}
      {/* {type == "product" || type == "moodboard" || type == "collection" ? ( */}
      {type == "product" || type == "moodboard" ? (
        <Tooltip
          title={
            inPortfolio
              ? `Unpublish this ${currentType?.name} from your public portfolio.`
              : `Publish this ${currentType?.name} to your public portfolio.`
          }
          placement="left"
        >
          <MenuItem
            onClick={() => {
              if (!inPortfolio) {
                if (type == "collection") {
                  setImportCollectionVisible(true);
                } else if (type == "moodboard") {
                  setPublishMoodboard(true);
                } else if (type == "product") {
                  setImportStyleVisible(true);
                }
              } else {
                setUnpublishedMoodboard(true);
              }
              handleCloseStyleImportMenu();
            }}
          >
            <SuiBox>
              <SuiBox sx={{ cursor: "pointer" }}>
                <SuiBox display="flex" alignItems="center" justifyContent="flex-start" gap={1}>
                  {inPortfolio ? (
                    <UnpublishedIcon fontSize="small" />
                  ) : (
                    <PublishIcon fontSize="small" />
                  )}

                  <SuiTypography variant="body1" textAlign="center">
                    {inPortfolio ? "Unpublish from portfolio" : "Publish to Portfolio"}
                  </SuiTypography>
                </SuiBox>
              </SuiBox>
            </SuiBox>
          </MenuItem>
        </Tooltip>
      ) : null}
      {type == "product" || type == "moodboard" ? (
        <Tooltip title={`Use current ${currentType?.name} to create a post.`} placement="left">
          <MenuItem
            onClick={() => {
              navigate(`/post/create?pid=${data.id}&ptype=${type}`);
              handleCloseStyleImportMenu();
            }}
          >
            <SuiBox>
              <SuiBox sx={{ cursor: "pointer" }}>
                <SuiBox display="flex" alignItems="center" justifyContent="flex-start" gap={1}>
                  <ClassIcon fontSize="small" />

                  <SuiTypography variant="body1" textAlign="center">
                    {"Create a Post"}
                  </SuiTypography>
                </SuiBox>
              </SuiBox>
            </SuiBox>
          </MenuItem>
        </Tooltip>
      ) : null}
    </Menu>
  );

  const sorted = collaboratorUsers.sort((a, b) => {
    let storeA = a?.user?.stores && a?.user?.stores.length > 0 ? a?.user?.stores[0] : {};
    let storeB = b?.user?.stores && b?.user?.stores.length > 0 ? b?.user?.stores[0] : {};

    var inSessionA =
      sharedSessions !== null && sharedSessions.find((s) => s.senderId === storeA?.id);
    var inSessionB =
      sharedSessions !== null && sharedSessions.find((s) => s.senderId === storeB?.id);

    if (inSessionA && !inSessionB) {
      return -1;
    } else if (inSessionB && !inSessionA) {
      return 1;
    } else {
      return 0;
    }
  });

  return (
    <div style={{ marginBottom: "60px" }}>
      <SuiBox
        sx={{
          position: "fixed",
          top: 60,
          mb: 60,
          left: 0,
          height: 50,
          width: "100%",
          zIndex: 3,
        }}
      >
        <SuiBox
          shadow="md"
          sx={({ palette: { transparent: transparentColor, white }, functions: { rgba } }) => ({
            backgroundColor: rgba(white.main, 0.8),
            backdropFilter: `saturate(200%) blur(30px)`,
            borderRadius: 0,
            height: 50,
          })}
        >
          <SuiBox
            sx={{
              position: "relative",
              width: "100%",
              height: 50,
              maxWidth: { lg: MAX_SCREEN_WIDTH + 100, md: MAX_SCREEN_WIDTH - 20 },
              px: 4,
              margin: "0px auto",
            }}
          >
            <div
              style={{
                position: "absolute",
                left: 0,
                bottom: "25%",
                width: "100%",
                textAlign: "center",
              }}
            >
              <SuiBox display="flex" justifyContent="center" alignItems="center">
                {data?.mode == 2 && isOwner ? (
                  <Tooltip title={"Click to unlock"}>
                    <LockIcon
                      fontSize="small"
                      sx={{ cursor: "pointer", mr: 0.5 }}
                      onClick={handleToggleLock}
                    />
                  </Tooltip>
                ) : null}
                {sharedTitle}
              </SuiBox>
            </div>

            <SuiBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{ height: "100%", zIndex: 3 }}
            >
              <SuiBox sx={{ zIndex: 2 }} display="flex" alignItems="center" gap={1}>
                <SuiButton variant="text" color="dark" onClick={() => navigate(-1)} size="large">
                  <ArrowBackIcon fontSize="sm" sx={{ mr: 0.5 }} /> Back
                </SuiButton>
                {type == "product" && isOwner && projectInfo?.id ? (
                  formatProjectInfo(data)
                ) : (
                  <div />
                )}
              </SuiBox>{" "}
              {data?.id && !ActionGroup ? (
                <SuiBox>
                  <SuiBox display="flex" alignItems="center" justifyContent="center" gap={1}>
                    {loading ? (
                      <div />
                    ) : (
                      <SuiBox>
                        <SharedUserList2
                          item={data}
                          type={type}
                          collaboratorUsers={sorted}
                          size="md"
                          handleAddCollaborator={isOwner ? () => setShareVisible(true) : null}
                          sharedSessions={sharedSessions}
                          handleRefresh={handleRefresh}
                          isOwner={isOwner}
                          ownerStore={ownerStore}
                          handleAdditionalAvatarClick={() => setShareVisible(true)}
                        />
                      </SuiBox>
                    )}
                    {isOwner && !loading ? (
                      <SuiButton
                        onClick={() => setShareVisible(true)}
                        color="dark"
                        sx={{
                          padding: "0px 8px",
                          fontSize: 12,
                          lineHeight: 0,
                          minHeight: 25,
                          minWidth: 25,
                          textTransform: "none",
                          borderRadius: "4px",
                        }}
                        size="small"
                      >
                        {" "}
                        Share
                      </SuiButton>
                    ) : (
                      <div />
                    )}

                    {isSharedToAll?.id && !isOwner && type == "product" ? (
                      <SuiButton
                        onClick={() => setImportStyleConfirmation(true)}
                        color="info"
                        sx={{
                          padding: "0px 8px",
                          fontSize: 12,
                          lineHeight: 0,
                          minHeight: 25,
                          minWidth: 25,
                          textTransform: "none",
                          borderRadius: "4px",
                        }}
                        size="small"
                      >
                        Import
                      </SuiButton>
                    ) : (
                      <div />
                    )}

                    {!loading ? (
                      <Badge variant="dot" color="error" invisible={!currentRoom?.isnew}>
                        <SuiTypography
                          variant="body1"
                          color="dark"
                          sx={{ cursor: "pointer", mr: 1, zIndex: 2 }}
                          onClick={(e) => {
                            if (!chatVisible) {
                              setCurrentRoom({ ...currentRoom, isnew: false });
                            }

                            setChatVisible(!chatVisible);
                          }}
                        >
                          Discussion
                        </SuiTypography>
                      </Badge>
                    ) : (
                      <div />
                    )}
                    {isOwner ? (
                      <SuiBox
                        display="flex"
                        alignItems="center"
                        sx={{ cursor: "pointer", zIndex: 2 }}
                        onClick={(e) => {
                          setActionmenuVisible(e.target);
                        }}
                      >
                        <SuiTypography
                          variant="body1"
                          color="dark"
                          sx={{ cursor: "pointer", zIndex: 2 }}
                          verticalAlign="middle"
                        >
                          More
                        </SuiTypography>
                        <KeyboardArrowDownIcon fontSize="small" />
                      </SuiBox>
                    ) : null}
                    {extraAction ? extraAction : null}
                  </SuiBox>
                </SuiBox>
              ) : ActionGroup ? (
                ActionGroup
              ) : null}
              {isOwner && !loading && data?.id ? (
                <ActionMenu isSharedToAllDesigners={isSharedToAllDesigners} />
              ) : null}
              {publishMoodboard ? (
                <Prompt
                  heading={`Publish ${currentType.name}`}
                  text={`Do you want to publish the ${currentType.name} to your portfolio ${currentType.section}?`}
                  visible={publishMoodboard}
                  okText={"Publish"}
                  okColor="dark"
                  handleOk={async () => {
                    try {
                      if (account.id) {
                        try {
                          //refresh data
                          if (!portfolioData[slot]) {
                            portfolioData[slot] = [];
                          }
                          if (type == "moodboard" && data?.id) {
                            const mb = await api.moodboard.get(data.id);

                            let record = {
                              id: data?.id,
                              title: mb?.data?.moodboard?.name,
                              img: mb?.data?.moodboard?.img,
                              type: currentType.type,
                            };
                            portfolioData[slot].push(record);
                            let payload = {
                              metadata: {
                                ...account?.metadata,
                                portfolio_content: portfolioData,
                              },
                            };

                            await api.account.update(account.id, payload);
                            await account.handleRefresh();

                            toast.success(`Publish the ${currentType.name} successfully!`);
                          } else {
                            console.log(data);
                            toast.error(
                              `Publish the ${currentType.name} failed, Image is not ready!`
                            );
                          }
                        } catch (err) {
                          console.log(err);
                          toast.error(`Publish the ${currentType.name} failed!`);
                        }
                        setPublishMoodboard(false);
                      } else {
                        toast.error(
                          `Failed to publish the ${currentType.name}, Can't find the user!`
                        );
                      }
                    } catch (err) {
                      toast.error(`Publish the ${currentType.name} failed!`);
                    }
                  }}
                  handleClose={() => setPublishMoodboard(false)}
                />
              ) : null}
              {unpublishedMoodboard ? (
                <Prompt
                  heading={`Unpublish ${currentType.name}`}
                  text={`Do you want to unpublish the ${currentType.name} from your portfolio ${
                    currentType.section
                  }? 
          ${
            type == "collection"
              ? "This will remove all styles from the portfolio which belong to this collection."
              : ""
          }`}
                  visible={unpublishedMoodboard}
                  okText={"Unpublish"}
                  okColor="warning"
                  handleOk={async () => {
                    if (account.id) {
                      try {
                        await account.handleRefresh();
                        //get moodboard screenshot
                        if (!portfolioData[slot]) {
                          portfolioData[slot] = [];
                        }
                        if (type == "collection") {
                          const findIndex = portfolioData[slot].findIndex((x) => x.cid == data.id);
                          portfolioData[slot].splice(findIndex, 1);
                        } else if (type == "moodboard" || type == "product") {
                          const findIndex = portfolioData[slot].findIndex((x) => x.id == data.id);
                          portfolioData[slot].splice(findIndex, 1);
                        }
                        let payload = {
                          metadata: {
                            ...account?.metadata,
                            portfolio_content: portfolioData,
                          },
                        };

                        await api.account.update(account.id, payload);
                        await account.handleRefresh();
                        toast.success(`Unpublish the ${currentType.name} successfully!`);
                      } catch (err) {
                        console.log(err);
                        toast.error(`Unpublish the ${currentType.name} failed!`);
                      }
                      setUnpublishedMoodboard(false);
                    } else {
                      toast.error(
                        `Failed to unpublish the ${currentType.name}, Can't find the user!`
                      );
                    }
                  }}
                  handleClose={() => setUnpublishedMoodboard(false)}
                />
              ) : null}
              {importStyleVisible ? (
                <ImportSingleStyleModal
                  handleClose={() => setImportStyleVisible(false)}
                  visible={importStyleVisible}
                  isEdit={false}
                  categoryTree={[]}
                  collection={null}
                  product={data}
                  lockProduct
                  slot={SLOT_MAP.product.slot}
                  handleRefresh={() => account.handleRefresh()}
                />
              ) : null}
              {importCollectionVisible ? (
                <ImportSingleCollectionModal
                  handleClose={() => setImportCollectionVisible(false)}
                  visible={importCollectionVisible}
                  isEdit={false}
                  collection={data}
                  handleOk={handleUpdateCollection}
                  lockCollection
                  slot={SLOT_MAP.collection.slot}
                />
              ) : null}
              {createCollectionVisible ? (
                <CreateCollectionModal
                  handleClose={() => setCreateCollectionVisible(false)}
                  visible={createCollectionVisible}
                  isEdit={false}
                  handleAfterOk={handleAfterCreateCollectionOk}
                />
              ) : null}
              {collectionMoodboardVisible ? (
                <SetMoodboardCollectionModal
                  handleClose={() => setCollectionMoodboardVisible(false)}
                  visible={collectionMoodboardVisible}
                  isEdit={false}
                  moodboard={data}
                />
              ) : null}
            </SuiBox>
          </SuiBox>
        </SuiBox>
        {chatVisible ? (
          <Card
            sx={{
              maxWidth: "500px",
              minWidth: "500px",
              maxHeight: "100%",
              overflow: "auto",
              zIndex: 2000,
              borderRadius: 2,
              position: "fixed",
              top: 100,
              right: 10,
            }}
          >
            <SuiBox px={2} py={1} display="flex" justifyContent="space-between" alignItems="center">
              <SuiBox>
                <SuiTypography variant="h5">Discussion</SuiTypography>
              </SuiBox>
              <IconButton
                aria-label="close"
                onClick={() => setChatVisible(false)}
                sx={{
                  float: "right",
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            </SuiBox>

            <SuiBox sx={{ overflow: "auto" }}>
              <ChatRoom id={currentRoom?.id} />
            </SuiBox>
          </Card>
        ) : null}
        {shareVisible ? (
          <ShareListModal
            item={data}
            type={type}
            visible={shareVisible}
            handleClose={() => setShareVisible(false)}
            handleOpen={() => setShareVisible(true)}
            permittedUsers={permittedUsers}
            handleRefresh={handleRefresh}
            permittedCollectionUsers={permittedCollectionUsers}
          />
        ) : null}
        {lockVisible?.[type] ? (
          <Prompt
            heading={`Lock ${currentType.name}`}
            text={`Are you sure you want to lock your ${currentType.name}? No one will be able to make any change until you unlock it.!`}
            visible={lockVisible?.[type]}
            okText={"Lock"}
            okColor="dark"
            handleOk={async () => {
              try {
                if (type == "moodboard") {
                  await api.moodboard.setMode(data.id, { mode: 2 });
                } else if (type == "product") {
                  await api.products.setMode(data.id, { mode: 2 });
                } else {
                  toast.error(`No supported type!`);
                  return;
                }

                handleRefreshSourceData();

                toast.success(`Lock the ${currentType.name} successfully!`);
              } catch (err) {
                console.log(err);
                toast.error(`Lock the ${currentType.name} failed!`);
              }
              setLockVisible({});
            }}
            handleClose={() => setLockVisible({})}
          />
        ) : null}
        {unlockVisible?.[type] ? (
          <Prompt
            heading={`Unlock ${currentType.name}`}
            text={`Are you sure you want to unlock your ${currentType.name}? All collaborators with "EDITOR" permission can make changes to your Moodboard!`}
            visible={unlockVisible?.[type]}
            okText={"Unlock"}
            okColor="dark"
            handleOk={async () => {
              try {
                if (type == "moodboard") {
                  await api.moodboard.setMode(data.id, { mode: 0 });
                } else if (type == "product") {
                  await api.products.setMode(data.id, { mode: 0 });
                } else {
                  toast.error(`No supported type!`);
                  return;
                }
                handleRefreshSourceData();

                toast.success(`Unlock ${currentType.name} successfully!`);
              } catch (err) {
                console.log(err);
                toast.error(`Unlock ${currentType.name} failed!`);
              }
              setUnlockVisible({});
            }}
            handleClose={() => setUnlockVisible({})}
          />
        ) : null}
        {shareToAllDesiignersVisible ? (
          <Prompt
            heading={`Share to all designers`}
            text={`Do you want to share the content:${currentType.name} to all designers!`}
            visible={shareToAllDesiignersVisible}
            okText={"Share"}
            okColor="dark"
            handleOk={async () => {
              try {
                await api.resourcePermission.grantAll({
                  resource_id: data.id,
                  resource_type: type,
                });
                handleRefreshSourceData();
                handleRefresh();

                toast.success(`Share ${currentType.name} to all designers successfully!`);
              } catch (err) {
                console.log(err);
                toast.error(`Share ${currentType.name} to all designers failed!`);
              }
              setShareToAllDesiignersVisible(false);
            }}
            handleClose={() => setShareToAllDesiignersVisible(false)}
          />
        ) : null}
        {unshareToAllDesiignersVisible ? (
          <Prompt
            heading={`Unshare to all designers`}
            text={`Do you want to unshare the content:${currentType.name} to all designers!`}
            visible={unshareToAllDesiignersVisible}
            okText={"Unshare"}
            okColor="error"
            handleOk={async () => {
              try {
                await api.resourcePermission.revoke({
                  permissions: [
                    { resource_id: data.id, resource_type: type, user_id: "AllDesigners" },
                  ],
                });
                handleRefreshSourceData();
                handleRefresh();

                toast.success(`Unshare ${currentType.name} to all designers successfully!`);
              } catch (err) {
                console.log(err);
                toast.error(`Unshare ${currentType.name} to all designers failed!`);
              }
              setUnshareToAllDesiignersVisible(false);
            }}
            handleClose={() => setUnshareToAllDesiignersVisible(false)}
          />
        ) : null}

        {importStyleConfirmation ? (
          <Prompt
            heading={`Import Style`}
            text={`Do you want to import the style:${data?.title} to your style library!`}
            visible={importStyleConfirmation}
            okText={"Import"}
            okColor="dark"
            handleOk={async () => {
              try {
                const newStyle = await api.products.duplicate(data.id);

                toast.success(`Import style:${data?.title} successfully!`);
                navigate(`/workspace/styles-master?id=${newStyle?.data?.product?.id}`);
                setImportStyleConfirmation(false);
              } catch (err) {
                console.log(err);
                toast.error(`Failed to import style:${data?.title}!`);
              }
            }}
            handleClose={() => setImportStyleConfirmation(false)}
          />
        ) : null}
      </SuiBox>
    </div>
  );
};

export default NewSharedBar;
